import {gql} from 'react-apollo';

// Query to fetch a specific store order template by ID
export const STORE_ORDER_TEMPLATE_QUERY = gql`
  query StoreOrderTemplateQuery($templateId: String!) {
    storeOrderTemplate(id: $templateId) {
      id
      name
      fields {
        name
        label
        type
        required
        picklist
        disabled
        columns {
          name
          label
          type
          picklist
        }
        initialRows
        initialValue
        help
      }
    }
  }
`;

// Mutation to create a store order
export const CREATE_STORE_ORDER_MUTATION = gql`
  mutation CreateStoreOrderMutation($storeOrder: StoreOrderInput!) {
    createStoreOrder(storeOrder: $storeOrder) {
      id
      CreatedAt
    }
  }
`;
